import { get, post } from '@nbx/frontend-helpers/fetch-api';

let baseUrl = 'referrals';

const NBXReferral = {
  init: config => ({ baseUrl } = config),

  validate: code => get(`${baseUrl}/validate/${code}`),

  postUsedReferral: (referralCode, firebaseToken) => {
    return post(`${baseUrl}/signup`, {
      json: { referralCode },
      headers: { Authorization: `bearer ${firebaseToken}` }
    });
  },

  postCardPartnership: (cardPartnershipCode, firebaseToken) => {
    return post(`${baseUrl}/signup`, {
      json: { cardPartnershipCode },
      headers: { Authorization: `bearer ${firebaseToken}` }
    });
  }
};

export default NBXReferral;
